class TokenizerError extends Error {}
class UnknownCharacterError extends TokenizerError {}
class ExpectedCharacterError extends TokenizerError {}

export default class Tokenizer {
  static whitespace = [' ', '\t', '\r', '\n']

  constructor(raw) {
    this.raw = raw
    this.length = raw.length
    this.index = -1
    this.expression = null
    this.errors = []

    this.lex()
  }

  get valid() {
    return this.errors.length === 0
  }

  current() {
    return this.raw[this.index]
  }

  willOverflow() {
    return this.index >= this.length - 1
  }

  terminate() {
    this.index = this.length
  }

  peek() {
    if (this.willOverflow()) {
      return null
    }
    return this.raw[this.index + 1]
  }

  chompSpace() {
    while (Tokenizer.whitespace.includes(this.peek())) {
      this.next()
    }
  }

  next() {
    if (this.willOverflow()) {
      return null
    }

    this.index++
    return this.raw[this.index]
  }

  lex() {
    while (!this.willOverflow()) {
      this.chompSpace()

      // End of input. Bail
      if (this.peek() === null) break

      // if this gets more complex, we need to start storing tokens in here,
      // but lets keep this simple
      this.expression = this.tokenize()
    }
  }
}

export { UnknownCharacterError, ExpectedCharacterError }
